import _ from 'lodash';
import { WPP_OS_PROD_DOMAIN, WPP_OS_STAGING_DOMAIN } from 'constantsBase';

export const isLoadedThroughWppOs = (): boolean => {
  const origin = document.referrer;
  return _.includes(origin, WPP_OS_PROD_DOMAIN) || _.includes(origin, WPP_OS_STAGING_DOMAIN);
};
